import styled from 'styled-components'
import { BqButton, BqCheckbox, BqSelect } from '@beeq/react'

export const UserListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-x: auto;
`

export const TableWrapper = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  padding-top: var(--bq-spacing-l);
  @media screen and (max-width: 1395px) {
    padding-top: var(--bq-spacing-xs);
  }
`
export const UserListGeneratedWrapper = styled.div`
  height: 100%;
  overflow-y: scroll;
`

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e8e8e8;
  padding-top: var(--bq-spacing-l);
  width: 100%;
  @media screen and (max-width: 1395px) {
    width: 1083px;
    padding-top: var(--bq-spacing-xs);
  }
`

export const TableTitleLeft = styled.p`
  width: ${(props) => props.$width};
  display: flex;
  align-items: center;
  text-align: left;
  font-weight: bold;
  padding-left: ${(props) => (props.$leftPadding ? props.$leftPadding : '1rem')};
`

export const NameInfoRowField = styled.div`
  width: ${(props) => (props.$width ? props.$width : '10%')};
  text-align: ${(props) => (props.$align ? props.$align : 'center')};
  padding-left: ${(props) => (props.$leftmargin ? props.$leftmargin : '1rem')};
  min-width: ${(props) => (props.$minwidth ? props.$minwidth : '50px')};
  align-items: center;
  white-space: nowrap;
  color: ${(props) => (props.$color ? props.$color : 'var(--bq-brand)')};
`
export const InfoRowInToolTip = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`

export const InfoRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 0 10px 0;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  white-space: normal;
  border-top: var(--bq-stroke-s, 1px) solid transparent;
  border-bottom: var(--bq-stroke-s, 1px) solid transparent;

  &:hover {
    background-color: color-mix(in srgb, transparent, var(--bq-hover) 5.8%);
  }

  &.active {
    background: var(--bq-ui--brand-alt);
    border-top: var(--bq-stroke-s, 1px) solid var(--bq-stroke--brand);
    border-bottom: var(--bq-stroke-s, 1px) solid var(--bq-stroke--brand);
  }
`

export const InfoRow = styled.div`
  width: ${(props) => (props.$width ? props.$width : '10%')};
  text-align: ${(props) => (props.$align ? props.$align : 'center')};
  padding-left: ${(props) => (props.$leftmargin ? props.$leftmargin : '1rem')};
  min-width: ${(props) => (props.$minwidth ? props.$minwidth : '50px')};
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StyledBqSelect = styled(BqSelect)`
  --bq-select--text-size: theme('fontSize.m');
  &::part(panel) {
    height: 250px;
  }
`
export const SpinnerWrapper = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const StyledBqCheckbox = styled(BqCheckbox)`
  pointer-events: none;
`

export const AdvancedSearchButton = styled(BqButton)`
  &::part(button) {
    border-width: 0;
  }

  &::part(label) {
    padding-inline: var(--bq-spacing-xs);
  }
`
